import React from "react";

import cx from "classnames";
import { get } from "lodash";

import Icons from "../../icons";
import likedSongsStore from "../../../zustand/likedSong.store";
import { ICONS } from "../../../constants/icons.constants";
import { songActions } from "../../../actions";

import styles from "./like.module.scss";
import userStore from "../../../zustand/user.store";
import disLikedSongsStore from "../../../zustand/dislikedSong.store";

const Like = ({ row }) => {
  const { songs: likedSongs, setLikeToSong } = likedSongsStore();
  const { removeDislikeFromSong } = disLikedSongsStore();

  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  const id = get(row, "id", "");

  const handleThumbUpClick = async (e) => {
    e.stopPropagation();
    setLikeToSong(id);
    removeDislikeFromSong(id);

    const isSuccess = await songActions.addReactionToSong(
      id,
      "LIKE",
      userOffline
    );

    if (!isSuccess) {
      setLikeToSong(id);
      removeDislikeFromSong(id);
    }
  };

  return (
    <div className={cx(styles.iconContainer)} onClick={handleThumbUpClick}>
      {!get(likedSongs, id, false) ? (
        <Icons type={ICONS.THUMBS_UP} />
      ) : (
        <Icons type={ICONS.THUMBS_UP_FILLED} />
      )}
    </div>
  );
};

export default Like;
